import pino from "pino";

export default pino({
  level: process.env.NEXT_PUBLIC_LOG_LEVEL ?? "info", // info and above in all environments
});
